import { SupportLink } from "@/components/custom/Link/SupportLink"

export const LOCKED_EMAIL_FIELD_MESSAGE = <p>
  To change your email address, please contact us at <SupportLink />.
</p>

export const DATA_SOURCE_MESSAGE = <p>
  This is an app where you want to get data from. Select the credential you want to use for this data source.
</p>

export const TRIGGERING_EVENT_MESSAGE = <p>
  How do you want to run this workflow? What do you want to get from this source?
</p>

export const ADD_FILTER_MESSAGE = <p>
  Select the filters you want to use for this workflow
</p>

export const DATA_DESTINATION_MESSAGE = <p>
  This is an app where you want to save data to.
</p>

export const BB_CRED_CREATE_APP_HELP = <p>
  If you are not sure where you can get from, please create an app on blackbaud, this will give you Client ID and Secret.
  Please make sure you <strong>connect</strong> it to use it in the workflow.
</p>

export const BB_CRED_CREATE_SUBSCRIPTION_HELP = <p>
  If you are not sure where you can get from, please create an app on blackbaud, this will give you Client ID and Secret.
  Please make sure you <strong>connect</strong> it to use it in the workflow.
</p>
